/**
 * Constant
 * --------
 * 
 * June 2026
 */

import { InputNumber } from "primereact/inputnumber";

/**
 * Component for editing a constant value for an element's attribute.
 * 
 * @param {String} elementType      - Type of element tied to distribution. (actions, resources, entity_types)
 * @param {Object} element          - Attributes for an element being edited.
 * @param {Object} attr             - Distribution parameters tied with element attribute.
 * @param {Function} distUpdater    - Sets which distribution is currently being used.
 * @param {Function} warningUpdater - Updates warnings for an element parameter.
 * @param {Object} configWarnings   - Verification warnings for model elements.
*/
function Constant({ elementType, element, attr, distUpdater, warningUpdater, configWarnings }) {
    const constantWarnings = {
        'constant': function(newValue) { return newValue < 0 ? `${attr} - Constant value must be positive` : null }
    }
    
    /**
     * Updates the constant value for an attribute.
     * 
     * @param {float} newValue  - Updated value for the constant.
     */
    const handleConstant = (newValue) => {
        warningUpdater(element.gid, attr, constantWarnings['constant'](newValue));

        const newConstant = {...element[attr].attr, value: newValue};
        const newDist = {...element[attr], attr: newConstant};
        distUpdater(attr, newDist);
    }

    return (
        <div>
            <label style={{ marginRight: '0.5rem' }}>Value:</label>
            <InputNumber value={element[attr].attr.value} onValueChange={(event) => handleConstant(event.target.value)} invalid={!!configWarnings[elementType]?.[element.gid]?.[attr]} inputStyle={{ width: '110px' }}/>
        </div>
    )
}

export default Constant;